import { Component, inject } from "@angular/core";
import { LG_AUTHENTICATION_SERVICE, LG_USER_INFO } from "@logex/framework/lg-application";
import { useTranslationNamespace } from "@logex/framework/lg-localization";
import {
    IQuickSettingsMenuChoice,
    LgConfirmationDialog,
    QuickSettingsMenuType
} from "@logex/framework/ui-core";
import { SharedAppUser } from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";
import { Auth0AuthenticationService } from "libs/shared/util-authorization/src/lib/auth0-authentication.service";

@Component({
    selector: "mrdm-self-service-frontend-account-button",
    templateUrl: "./account-button.component.html",
    styleUrls: ["./account-button.component.scss"],
    providers: [useTranslationNamespace("APP._AccountButton")],
    standalone: false
})
export class AccountButtonComponent {
    _userInfo = inject<SharedAppUser>(LG_USER_INFO);
    private _auth0AuthenticationService = inject<Auth0AuthenticationService>(LG_AUTHENTICATION_SERVICE);
    private _confirmDialog = inject(LgConfirmationDialog);

    _options: IQuickSettingsMenuChoice[] = this._getOptions();

    public logout(): void {
        this._auth0AuthenticationService.logout();
    }

    public endImpersonation(): void {
        this._confirmDialog
            .confirmLC(
                "FW._Sidebar._Impersonation.EndImpersonationConfirmation.Title",
                "FW._Sidebar._Impersonation.EndImpersonationConfirmation.Text"
            )
            .then(choice => {
                if (choice === 1) {
                    this._auth0AuthenticationService.endImpersonation().then(() => {
                        window.location.reload();
                    });
                }
            });
    }

    private _getOptions(): IQuickSettingsMenuChoice[] {
        return [
            {
                id: "logout",
                nameLC: ".Logout",
                type: QuickSettingsMenuType.Choice,
                onClick: () => this.logout()
            },
            {
                id: "endImpersonation",
                nameLC: ".EndImpersonation",
                type: QuickSettingsMenuType.Choice,
                visible: () => !!this._userInfo.impersonator,
                onClick: () => this.endImpersonation()
            }
        ];
    }
}
